import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {
    ERR_MSG,

} from "../constants/constants";
import {LOGOUT_URL} from "../config/url-config";



export const logoutService = (url)=>{

    return new Promise((resolve,reject)=>{
        axiosInstance
            .get(LOGOUT_URL())
            .then((response) => {
                console.log("response",response)
                resolve(response)
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}